import { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import Loader from './components/Common/Loader';
import Routing from './components/Routing';
import ErrorBoundary from './utils/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <Router>
          <Routing />
        </Router>
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;
